import type { ThemeConfig } from "antd";

// Design tokens for the new UI (see ui-mockup/ in the repo root).
export const NEW_UI_THEME: ThemeConfig = {
  token: {
    colorPrimary: "#5e6ad2",
    colorInfo: "#5e6ad2",
    colorSuccess: "#2e9e6b",
    colorWarning: "#c98a1b",
    colorError: "#d1453b",
    colorText: "#1a1a1a",
    colorBgLayout: "#f7f7f6",
    borderRadius: 8,
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    Layout: {
      siderBg: "#fafafa",
      headerBg: "#ffffff",
      bodyBg: "#f7f7f6",
    },
    Menu: {
      itemBg: "transparent",
      itemSelectedBg: "#eef0fd",
      itemSelectedColor: "#5e6ad2",
      itemColor: "#6b6b66",
      itemHoverBg: "#f0f0ee",
    },
  },
};
